/**
 * @internal
 */
export class ZOptionBase {
    #impl;
    constructor(impl) {
        this.#impl = impl;
    }
    get name() {
        return this.#impl.name;
    }
    get key() {
        return this.#impl.key;
    }
    get args() {
        return this.#impl.args;
    }
    get argIndex() {
        return this.#impl.argIndex;
    }
    values(max) {
        this.recognize();
        return this.#impl.values(false, max);
    }
    rest(max) {
        this.recognize();
        return this.#impl.values(true, max);
    }
    recognize(action) {
        return this.#impl.recognize(action);
    }
    defer(whenRecognized) {
        this.unrecognize();
        this.#impl.defer(whenRecognized);
    }
    unrecognize(reason) {
        this.#impl.unrecognize(reason);
    }
    whenRecognized(receiver) {
        this.#impl.whenRecognized(receiver);
    }
    optionLocation(init) {
        return this.#impl.optionLocation(init);
    }
    supportedOptions() {
        return [...this.#impl.optionsMeta().keys()];
    }
    optionMeta(key) {
        return this.#impl.optionsMeta().get(key) || { usage: [] };
    }
}
//# sourceMappingURL=option-base.impl.js.map